import React, { Component} from 'react';
import { FormattedMessage } from 'react-intl';
import "react-dropdown/style.css";

import axios from "axios";
import get from 'lodash/get';

import epicBanner from 'assets/epic-banner.png';
import epicBannerFr from 'assets/epic-banner_fr.png';
import PageTitle from 'shared/PageTitle';
import Auth from 'shared/Auth';
import Text from 'ui/Text';

class CSOShortlist extends Component{
  constructor(){
    super();

    this.state = {
      shortlistedCSOs: [[{
          name: 'HakiElimu',
          category: 'Overall',
          category_fr: 'Gagnante Principale',
          website: 'www.hakielimu.org',
          location: 'Tanzania',
          location_fr: 'Tanzanie',
          area_of_focus: 'Education, Gender Equality, Governance (Economic, Public Policy, Transparency, Legal and Judicial Frameworks) , Human Rights',
          area_of_focus_fr: "Education, Egalité des sexes, gouvernance (Economie, Politique publique, Transparence, Cadres juridique et judiciaire), droits de l'homme",
          logo: 'https://s3.eu-central-1.amazonaws.com/epicafrica/9841f517-3f6a-11e9-9413-0271900258b6-HakiElimu.jpg'
        }],
        [{
          name: 'HakiElimu',
          category: 'Strategic Ability and Adaptability',
          category_fr: "Capacité stratégique et adaptabilité",
          website: 'www.hakielimu.org',
          location: 'Tanzania',
          location_fr: 'Tanzanie',
          area_of_focus: 'Education, Gender Equality, Governance (Economic, Public Policy, Transparency, Legal and Judicial Frameworks) , Human Rights',
          area_of_focus_fr: "Education, Egalité des sexes, gouvernance (Economie, Politique publique, Transparence, Cadres juridique et judiciaire), droits de l'homme",
          logo: 'https://s3.eu-central-1.amazonaws.com/epicafrica/9841f517-3f6a-11e9-9413-0271900258b6-HakiElimu.jpg'
        }, {
            name: 'HakiElimu',
            category: 'Leadership and Governance',
            category_fr: 'Leadership et Gouvernance',
            website: 'www.hakielimu.org',
            location: 'Tanzania',
            location_fr: 'Tanzanie',
            area_of_focus: 'Education, Gender Equality, Governance (Economic, Public Policy, Transparency, Legal and Judicial Frameworks) , Human Rights',
            area_of_focus_fr: "Education, Egalité des sexes, gouvernance (Economie, Politique publique, Transparence, Cadres juridique et judiciaire), droits de l'homme",
            logo: 'https://s3.eu-central-1.amazonaws.com/epicafrica/9841f517-3f6a-11e9-9413-0271900258b6-HakiElimu.jpg'
          }, {
            name: 'KCDF',
            category: 'Financial Health and Management',
            category_fr: 'Santé et Gestion Financières',
            website: 'www.kcdf.or.ke',
            location: 'Kenya',
            location_fr: 'Kenya',
            area_of_focus: 'Education, Resource Governance (land rights, extractive industries, natural resources), Youth, Entrepreneurship',
            area_of_focus_fr: "Education, Gouvernance des ressources (droits des terres, industries extractives, ressources naturelles), Jeunesse, Entrepreunariat",
            logo: 'https://s3.eu-central-1.amazonaws.com/epicafrica/e4e5d101-3f61-11e9-9410-0271900258b6-KCDF_logo.jpg'
          }], [{
            name: 'Ghana Center for Democratic Development',
            category: 'Human Resources and Staff Development',
            category_fr: 'Développement des Ressources Humaines et du Personnel',
            website: 'www.cddgh.org',
            location: 'Ghana',
            location_fr: 'Ghana',
            area_of_focus: 'Governance (Economic, Public Policy, Transparency, Legal and Judicial Frameworks) , Human Rights, Resource Governance (land rights, extractive industries, natural resources), Conflict Resolution / Peace and Security',
            area_of_focus_fr: "Gouvernance (Economie, Politique publique, Transparence, justice), droits de l'homme, gouvernance des ressources (droits fonciers, industries extractives, ressources naturelles), Résolution des conflits / Paix et Sécurité",
            logo: 'https://s3.eu-central-1.amazonaws.com/epicafrica/ece29b18-3f60-11e9-940f-0271900258b6-unnamed.jpg'
        }, {
            name: 'HOPE worldwide Kenya',
            category: 'Operations',
            category_fr: "Gestion",
            website: 'www.hopewwkenya.org',
            location: 'Kenya',
            location_fr: 'Kenya',
            area_of_focus: 'HIV/AIDS, Youth, Entreprenuership, Health',
            area_of_focus_fr: "VIH/sida, Jeunesse, Entrepreneuriat, Santé",
            logo: 'https://s3.eu-central-1.amazonaws.com/epicafrica/5b3af605-3c34-11e9-93a8-0271900258b6-HWWK_-_Logo.jpg'
          }, {
            name: 'KCDF',
            category: 'Communications',
            category_fr: 'Communication',
            website: 'www.kcdf.or.ke',
            location: 'Kenya',
            location_fr: 'Kenya',
            area_of_focus: 'Education, Resource Governance (land rights, extractive industries, natural resources), Youth, Entrepreneurship',
            area_of_focus_fr: "Education, Gouvernance des ressources (droits des terres, industries extractives, ressources naturelles), Jeunesse, Entrepreunariat",
            logo: 'https://s3.eu-central-1.amazonaws.com/epicafrica/e4e5d101-3f61-11e9-9410-0271900258b6-KCDF_logo.jpg'
          }], [{
            name: "Centre d'Actions pour l'Environnement et le Développement Durable",
            category: 'Partnerships and Alliances',
            category_fr: "Partenariats et alliances",
            website: 'www.aced-benin.org',
            location: 'Benin',
            location_fr: 'Bénin',
            area_of_focus: 'Agriculture, Climate Change, Entreprenuership, Youth',
            area_of_focus_fr: "Agriculture, Changement Climatique, Entrepreneuriat, Jeunesse",
            logo: 'https://s3.eu-central-1.amazonaws.com/epicafrica/f5b7bb8c-3f78-11e9-9419-0271900258b6-logo-ACED.png'
          }, {
            name: 'Partage et Action en Synergie pour le Développement (PASYD)',
            category: 'Monitoring and Evaluation',
            category_fr: "Suivi et évaluation",
            website: 'www.pasyd.org',
            location: 'Togo',
            location_fr: 'Togo',
            area_of_focus: 'Entrepreneurship, Governance (Economic, Public Policy, Transparency, Legal and Judicial Frameworks), Gender Equality, Youth',
            area_of_focus_fr: "Entrepreneuriat, Gouvernance (économie, politique publique, transparence, cadres juridique et judiciaire), Égalité des sexes, Jeunesse",
            logo: 'https://s3.eu-central-1.amazonaws.com/epicafrica/977348b6-3f69-11e9-9413-0271900258b6-logo_1.jpg'
          }
        ]],
    }

    this.axiosHandler = axios.CancelToken.source();
  }

  getAreaOfFocus = (record) => {
    const defaultLang = get(Auth.getLanguage(), 'local_locale');

    const backgroundInfo = {
      fr: 'area_of_focus_fr',
      en: 'area_of_focus',
    };

    let areaOfFocus = get(record, get(backgroundInfo, defaultLang));

    return areaOfFocus;
  }

  getLocation = (record) => {
    const defaultLang = get(Auth.getLanguage(), 'local_locale');

    const backgroundInfo = {
      fr: 'location_fr',
      en: 'location',
    };

    let location = get(record, get(backgroundInfo, defaultLang));

    return location;
  }

  ge = (record) => {
    const defaultLang = get(Auth.getLanguage(), 'local_locale');

    const backgroundInfo = {
      fr: 'category_fr',
      en: 'category',
    };

    let category = get(record, get(backgroundInfo, defaultLang));

    return category;
  }  

  render() {
    const { shortlistedCSOs } = this.state;

    const defaultLang = get(Auth.getLanguage(), 'local_locale');

    const banner = {
      fr: epicBannerFr,
      en: epicBanner,
    };
    
    return (
      <div id="shortlisted-csos">
        <PageTitle title="Shortlisted CSOs" />
        <div>
          <div className="inner-content about-awards">
            <img src={get(banner, defaultLang)} alt="Epic Banner" />
          </div>
          <div className="inner-content about-explainer shortlisted-csos">
            <Text type="heading-semi-bold" modifiers="text-center title heavy col-sm-12 col-md-7 center-block">
              <FormattedMessage id="CSOShortlist.Discover" defaultMessage="The 2019 African CSO Excellence Awards Winners" />
            </Text>
            <div className="row no-margin">
              <div className="col-sm-12 col-md-9 col-lg-9 center-block">
                <Text type="explainer" modifiers="explanations-area plain-message text-center">
                  <FormattedMessage
                    id="CSOShortlist.Explanation.First"
                    defaultMessage="
                    Congratulations to the winners of the 2019 African CSO Excellence Awards. This is an impressive list of civil society organisations who thrive through organizational excellence. They have stood out  because of their  openness to being assessed and their commitment to learning and  growth.  These organizations are not only modeling best practices in terms of organizational effectiveness, but also crucially, helping  to start an important conversation in Africa about CSO transparency and accountability. 
                    "
                  />
                </Text>
              </div>
            </div>
            <div className="cso-listing">
                {
                  shortlistedCSOs.map((csoRow, index) => (
                    <div key={index} className="row no-margin justify-content-center">
                      {
                        csoRow.map((csoDetail, index) => (
                          <div key={index} className="col-sm-6 col-md-4 col-md-4 cso-detail animated fadeIn flex align-items-start justify-content-center">
                            <div>
                              <div className={`logo-cover`}>
                                <div style={{ backgroundImage: `url(${get(csoDetail, 'logo', '')})` }} className="logo"></div>
                              </div>
                              <Text type="heading-semi-bold" modifiers="primary-orange medium winner-title"><FormattedMessage id="CSOShortlist.Winner" defaultMessage="Winner" /></Text>
                              <Text type="sub-head-semi-bold" modifiers="primary-blue medium winner-topic">{this.ge(csoDetail)}</Text>
                              <div className="info-item text-center">
                                <Text type="small-bold" modifiers="description">
                                  <FormattedMessage id="CSOShortlist.Name" defaultMessage="Name" />: {get(csoDetail, 'name')}
                                </Text>
                              </div>
                              <div className="info-item">
                                <Text type="small-bold" modifiers="description">
                                  <FormattedMessage id="CSOShortlist.Website" defaultMessage="Website" />: <a className="value" href={`http://${get(csoDetail, 'website', '')}`} target="_blank">
                                    {get(csoDetail, 'website', '')}
                                  </a>
                                </Text>
                              </div>
                              <div className="info-item">
                                <Text type="small-bold" modifiers="description"><FormattedMessage id="CSOShortlist.Location" defaultMessage="Location" />: <span className="value">{this.getLocation(csoDetail)}</span></Text>
                              </div>
                              <div className="info-item">
                                <Text type="small-bold" modifiers="description"><FormattedMessage id="CSOShortlist.AreaOfFocus" defaultMessage="Area of Focus" /></Text>
                                <Text type="explanation" modifiers="description">{this.getAreaOfFocus(csoDetail)}</Text>
                              </div>
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  ))
                }
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default CSOShortlist;



// WEBPACK FOOTER //
// ./src/components/HomePage/CSOShortlist.js